// extracted by mini-css-extract-plugin
export var accordion = "Accordion-module--accordion--o-k+X";
export var accordionBox = "Accordion-module--accordionBox--r+xTF";
export var accordionOpen = "Accordion-module--accordionOpen--yX2A2";
export var body = "Accordion-module--body--sNGTU";
export var icon = "Accordion-module--icon--ERK5B";
export var title = "Accordion-module--title--2OMLa";
export var titleBox = "Accordion-module--titleBox--lCDaW";